<div class="pr-2 pl-2 d-flex justify-content-between">
    <input type="text"  placeholder="Search ID, Category, Card..." class="form-control col-lg-4 mt-1"
        (keyup)="updateFilter($event)"   />


</div>
<br>
<ngx-datatable class="material" [rows]="dataList" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
    [rowHeight]="'auto'" [scrollbarV]="false" [limit]="10" [sorts]="[{dir: 'desc'}]"
    style="position: relative !important;">
    <ngx-datatable-column [flexGrow]="1" name="ID" prop="categoryId">
        <ng-template let-row="row" ngx-datatable-cell-template>
            #{{row.autoId}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="1" name="Category" prop="categoryId">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span style="cursor: pointer; display: inline-block;" data-bs-toggle="modal" data-bs-target="#detailModal"
                (click)="openDetailModal(row,'detail')">{{row.guidanceCategoryId?.name}}</span>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="Card Name" prop="guidanceCardId">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span style="cursor: pointer; display: inline-block;" data-bs-toggle="modal" data-bs-target="#detailModal"
                (click)="openDetailModal(row,'detail')"> {{row.guidanceCardId?.name}}</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="3" name="Detail" prop="guidanceDetail">
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>

            @if (row.guidanceDetail) {
            <span style="cursor: pointer; display: inline-block;" data-bs-toggle="modal" data-bs-target="#detailModal"
                [innerHTML]="getFirstWords(row.guidanceDetail, 5)" [title]="getPlainTextFromHTML(row.guidanceDetail)"
                (click)="openDetailModal(row,'detail')">
            </span>
            } @else {
            <span style="color: #888;">-</span>
            }

        </ng-template>

    </ngx-datatable-column>

    <!-- <ngx-datatable-column [flexGrow]="3" name="Brief" prop="guidanceBrief">
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
            @if (row.guidanceBrief) {
            <span style="cursor: pointer; display: inline-block;" [innerHTML]="row.guidanceBrief"
                [title]="getPlainTextFromHTML(row.guidanceBrief)">
            </span>
            } @else {
            <span style="color: #888;">
                -
            </span>
            }

        </ng-template>

    </ngx-datatable-column> -->

    <ngx-datatable-column [flexGrow]="3" name="image" prop="image">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <img style="border: #b0b0b0 solid 2px;width: 66px;height: 66px; cursor: pointer;" class="rounded-circle"
                [src]="getSanitizeUrl(row.guidanceCardId.trimImage)" data-bs-toggle="modal"
                data-bs-target="#detailModal" (click)="openDetailModal(row, 'image')" />
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="2" name="Date">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.createdAt | date:'medium'}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="Edit">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <a [routerLink]="['/admin/guidance-detail/edit',row._id]"
                class="btn-table-custom btn btn-sm btn-outline-primary">Edit</a>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>


<!-- Button trigger modal -->


<!-- Modal -->
<div class="modal fade" id="detailModal" tabindex="-1" aria-labelledby="detailModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-start" style="gap: 1rem;">

                    <img style="border: #b0b0b0 solid 2px; width: 66px; height: 66px;" class="rounded-circle"
                        [src]="getSanitizeUrl(selectedRow?.guidanceCardId?.trimImage)" />

                    <!-- Right: Text block -->
                    <div>
                        <h5 class="modal-title mb-1">
                            {{selectedRow?.guidanceCardId?.name}}
                        </h5>
                        <small class="text-muted">
                            Category: {{selectedRow?.guidanceCategoryId?.name}}
                        </small>
                    </div>
                </div>

                <!-- Close button -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            @if (modalContentType=="detail") {

            <div class="modal-body" [innerHTML]="selectedRow?.guidanceDetail || '<p>No details available</p>'">
            </div>


            }
            @else {
            <!-- Template -->
            <img class="img-fluid full-screen-img" [src]="getSanitizeUrl(selectedRow?.guidanceCardId?.image)"
                alt="Guidance Card Image" />

            }


            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

            </div>
        </div>
    </div>
</div>